/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Settings_DescriptionInputs */

const vi_smartlab_settings_description = /** @type {(inputs: Smartlab_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản kết nối SmartLab (máy vò chè). Mật khẩu được mã hóa khi lưu và không bao giờ hiển thị lại.`)
};

/**

* @param {Smartlab_Settings_DescriptionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_settings_description = /** @type {((inputs?: Smartlab_Settings_DescriptionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Settings_DescriptionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_settings_description(inputs)
});